import React, { Fragment, useState } from "react";
import ReportService from "../../../services/ReportService";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import { REPORT_TYPES } from "../../config/constants";

const ReportModal = ({ show, onHide, type, reported, id }) => {
  const { t } = useTranslation();
  const [reportList] = useState(REPORT_TYPES);
  const [reportValue, setReportValue] = useState(0);
  const [doMessage, setDoMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const sendReport = () => {
    onHide();
    setLoading(true);
    let params = {
      type: type,
      reported: reported,
      reasons: reportValue,
      reasonsText: message,
      objId: id,
    };

    ReportService.sendReport({ ...params })
      .then((res) => {
        if (res.status === 200) {
          setLoading(false);
          toast.success(t("report.successfullySend"));
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  return (
    <Fragment>
      <Modal
        show={show}
        onHide={() => onHide()}
        keyboard={false}
        centered
      >
        <Modal.Header closeButton className="ps-3 pt-2 pb-2">
          <span className="text-color-dark fw-700 font-xssss">
            {t("report.title")}
          </span>
        </Modal.Header>
        {loading ? (
          <Modal.Body className="add-card-modal">
            <Loader />
          </Modal.Body>
        ) : (
          <Modal.Body
            className={`text-signal-card add-card-modal ${
              doMessage === true ? "pb-0" : ""
            }
                        `}
          >
            {doMessage === false && (
              <>
                <p
                  style={{ paddingBottom: "8px", paddingTop: "8px" }}
                  className="wallet-secret-text"
                >
                  {t("report.description")}
                </p>
                <div className="report-text flex-paginator-list">
                  {reportList.map((value, index) => (
                    <div
                      style={{ paddingBottom: "1px", paddingTop: "1px" }}
                      key={index}
                      onClick={() => {
                        setReportValue(index);
                        setDoMessage(true);
                      }}
                    >
                      <p className="report-category">{t(value)}</p>
                    </div>
                  ))}
                </div>
              </>
            )}

            {doMessage === true && (
              <>
                <p className="font-weight700 wallet-secret-text">
                  {t("report.reasons")}:
                </p>
                <p className="font-weight700 wallet-secret-text">
                  {t(reportList[reportValue])}
                </p>
                <div className="text-area-tip mb-16px">
                  <textarea
                    maxLength={150}
                    placeholder={t("report.reasons_placeholder")}
                    className="post-input no-resize"
                    onChange={(value) => setMessage(value.target.value)}
                  ></textarea>
                </div>

                <div className="report-action">
                  <p style={{ marginBottom: "4px" }}>
                    {t("report.action")}
                  </p>
                  <ul>
                    <li>{t("report.action_1")}</li>
                    <li>{t("report.action_2")}</li>
                    <li>{t("report.action_3")}</li>
                  </ul>
                </div>
              </>
            )}

            {doMessage === true && (
              <Modal.Footer className="d-flex p-2 justify-content-end border-0">
                <div
                  className="pointer fw-bold me-4 font-xsss text-silver"
                  onClick={() => onHide()}
                >
                  {t("report.cancel")}
                </div>

                <Button
                  className="fix-tip-button fw-bold me-2 rounded-pill font-xssss text-white px-3 py-2 pointer"
                  onClick={() => sendReport()}
                >
                  {t("report.submit")}
                </Button>
              </Modal.Footer>
            )}
          </Modal.Body>
        )}
      </Modal>
    </Fragment>
  );
};

export default ReportModal;
